import { useTranslation } from "react-i18next";
import { setUserLanguage } from "@/i18n";

const LANGS = ["en", "es", "pt"] as const;
type Lang = (typeof LANGS)[number];

const LABELS: Record<Lang, string> = {
  en: "EN",
  es: "ES",
  pt: "PT",
};

// Language name as written in the language the user is currently reading.
const NAME_IN: Record<Lang, Record<Lang, string>> = {
  en: { en: "English", es: "Spanish", pt: "Portuguese" },
  es: { en: "Inglés", es: "Español", pt: "Portugués" },
  pt: { en: "Inglês", es: "Espanhol", pt: "Português" },
};

const SWITCH_TO: Record<Lang, string> = {
  en: "Switch to",
  es: "Cambiar a",
  pt: "Mudar para",
};

const getCurrent = (lng?: string): Lang => {
  const code = lng?.slice(0, 2).toLowerCase();
  return (LANGS as readonly string[]).includes(code ?? "") ? (code as Lang) : "en";
};

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = getCurrent(i18n.language);
  const next = LANGS[(LANGS.indexOf(current) + 1) % LANGS.length];
  const title = `${SWITCH_TO[current]} ${NAME_IN[current][next]}`;

  return (
    <button
      onClick={() => setUserLanguage(next)}
      className="px-2.5 py-1 rounded-lg text-xs font-semibold border border-border/50 bg-secondary/50 text-muted-foreground hover:text-foreground hover:border-primary/30 transition-all"
      title={title}
      aria-label={title}
    >
      {LABELS[current]}
    </button>
  );
};

export default LanguageSwitcher;
